import {
  DEFAULT_RATIO_DENOMINATOR,
  DEFAULT_RATIO_NUMERATOR,
} from "./generateShapedPayoutTable";

export const HOUSE_HANDICAP_BASE = 230;
export const HOUSE_HANDICAP_PERCENTAGE = 80;
export const HOUSE_HANDICAP_MAX = 99;
export const HOUSE_PAYOUT_RATIO_NUMERATOR = DEFAULT_RATIO_NUMERATOR;
export const HOUSE_PAYOUT_RATIO_DENOMINATOR = DEFAULT_RATIO_DENOMINATOR;

export const emptyTournamentForm = () => ({
  name: "",
  startDate: "",
  description: "",
  scoringType: "handicap",
  handicapBase: "",
  handicapPercentage: "",
  handicapMax: "",
  payoutRatioNumerator: "",
  payoutRatioDenominator: "",
});
